// material-ui
import { styled } from '@mui/material/styles';

// project imports
import { MenuOrientation } from 'config';
import {
  drawerWidth,
  headerHeightHorizontal,
  headerHeightVertical,
  mainContentMarginLeft,
  mainContentMarginRight,
  mainContentTopPadding
} from 'store/constant';

interface MainStyleProps {
  open: boolean;
  menuOrientation: MenuOrientation;
  borderRadius: number;
}

// ==============================|| MAIN LAYOUT - STYLED ||============================== //

const MainContentStyled = styled('main', {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'menuOrientation' && prop !== 'borderRadius'
})<MainStyleProps>(({ theme, open, menuOrientation, borderRadius }) => {
  const headerHeight = menuOrientation === MenuOrientation.HORIZONTAL ? headerHeightHorizontal : headerHeightVertical;
  return {
    backgroundColor: theme.vars.palette.grey[100],

    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.dark[800]
    }),
    minWidth: '1%',
    width: '100%',
    minHeight: `calc(100vh - ${headerHeight}px)`,
    flexGrow: 1,
    paddingTop: mainContentTopPadding,
    paddingRight: 10,
    paddingBottom: 20,
    paddingLeft: 10,
    marginTop: headerHeight,
    marginRight: mainContentMarginRight,
    borderRadius: `${borderRadius}px`,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    ...(!open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shorter + 200
      }),
      [theme.breakpoints.up('md')]: {
        marginLeft: menuOrientation === MenuOrientation.VERTICAL ? -(drawerWidth - 72) : mainContentMarginLeft,
        width: `calc(100% - ${drawerWidth}px)`,
        marginTop: headerHeight
      }
    }),
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.shorter + 200
      }),
      marginLeft: menuOrientation === MenuOrientation.HORIZONTAL ? mainContentMarginLeft : 0,
      marginTop: headerHeight,
      width: `calc(100% - ${drawerWidth}px)`,
      [theme.breakpoints.up('md')]: {
        marginTop: headerHeight
      }
    }),
    [theme.breakpoints.down('md')]: {
      marginLeft: 20,
      paddingTop: mainContentTopPadding,
      paddingRight: 8,
      paddingBottom: 16,
      paddingLeft: 8,
      marginTop: headerHeightVertical,
      ...(!open && {
        width: `calc(100% - ${drawerWidth}px)`
      })
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 10,
      marginRight: 10
    }
  };
});

export default MainContentStyled;
